import "./Dpu_Mcs_Recognization.css";
const Dpu_Mcs_Recognization = () => {
  const recognitionLogos = [
    {
      img: "/assets/images/dpu_mca/highlight/Layer8.webp",
      alt: "AICTE",
    },
    {
      img: "/assets/images/dpu_mca/highlight/Layer2.webp",
      alt: "NIRF Top 50 Ranked in Universities",
    },
    {
      img: "/assets/images/dpu_mca/highlight/Layer9.webp",
      alt: "NAAC A Plus Plus Grade Accreditation",
    },
    {
      img: "/assets/images/dpu_mca/highlight/Layer7.webp",
      alt: "UGC",
    },
    {
      img: "/assets/images/dpu_mca/highlight/Layer4.webp",
      alt: "WES World Education Services",
    },
    {
      img: "/assets/images/dpu_mca/highlight/Layer3.webp",
      alt: "Times Higher Education 2024 Ranked 601 to 800 Overall",
    },
    {
      img: "/assets/images/dpu_mca/highlight/Layer5.webp",
      alt: "ISO 14001 2015",
    },
    {
      img: "/assets/images/dpu_mca/highlight/Layer6.webp",
      alt: "QS I Gauge Diamond",
    },
  ];

  const highlightStats = [
    { value: "40+", label: "Years' Legacy" },
    { value: "150,000+", label: "Strong Alumni" },
    { value: "1000+", label: "Faculty" },
    { value: "15", label: "World Class Institute" },
    { value: "500+", label: "Global Recruiter" },
  ];

  return (
    <section className="Dpu_Mcs_Recognization" id="recognitions">
      <div className="container">
        <div className="row">
          {/* Logos */}
          <div className="col-lg-5 text-center">
            {[0, 1].map((rowIndex) => (
              <div className="row" key={rowIndex}>
                {recognitionLogos
                  .slice(rowIndex * 4, rowIndex * 4 + 4)
                  .map((logo, index) => (
                    <div className="col-lg-3 col-md-3 col-3 mb-3" key={index}>
                      <img
                        src={logo?.img}
                        className="img-fluid"
                        alt={logo?.alt}
                      />
                    </div>
                  ))}
              </div>
            ))}
          </div>

          {/* Content */}
          <div className="col-lg-7 mt-3">
            <h2 className="text-white head_text">
              DPUCOL Accreditions & Recognitions
            </h2>
            <p className="text-white">
              Built on DPU’s strong legacy in education, DPU-COL brings quality
              learning to students beyond geographical limits. Designed for
              modern learners, its programs bridge the gap between academic
              knowledge and industry demands. India’s first Comfort Learning
              Platform, it offers a seamless, case study-driven online
              experience curated by top academicians and business experts.
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="row justify-content-center mt-3">
          {highlightStats.map((item, index) => (
            <div
              className="col-lg-2 col-md-4 col-6 text-center mb-3"
              key={index}
            >
              <div className="highlight-stats">
                <h5 className="mb-0 text-white ">
                  <strong>{item.value}</strong>
                </h5>
                <small className="mb-0 text-white">{item.label}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Dpu_Mcs_Recognization;
